import React, { useEffect, useRef } from "react";
import Username from "../../common/Username";
import ThreadPrefixes from "../../common/ThreadPrefixes";
import { MediaPlayer, MediaProvider } from "@vidstack/react";
import { defaultLayoutIcons, DefaultVideoLayout } from "@vidstack/react/player/layouts/default";
import VideoItemActionButtons from "./VideoItemActionButtons";
import UserAvatar from "../../common/UserAvatar";
import CommentList from "./CommentList";

const VideoMediaPlayer = ({ video, isActive, onOpenCommentList }) => {
	const playerRef = useRef(null);

	useEffect(() => {
		const mediaPlayer = playerRef.current;

		mediaPlayer.controls.hide();

		if (isActive && mediaPlayer && mediaPlayer.canPlay) {
			mediaPlayer.play();
		} else if (mediaPlayer) {
			mediaPlayer.pause();
		}
	}, [isActive]);

	return (
		<>
			<MediaPlayer
				ref={playerRef}
				title={video.Attachment.filename}
				src={video.Attachment.direct_url}
				className="media-player-fullscreen w-full h-full"
				autoplay={false}
				loop
				playsinline
			>
				<MediaProvider className="w-full h-full" />
				<DefaultVideoLayout icons={defaultLayoutIcons} />
			</MediaPlayer>

			<div className="absolute bottom-16 left-0 right-0 pl-2 pr-4 z-20">
				<div className="flex items-end w-full">
					<div className="flex-1 h-full min-w-0 pr-4">
						<div className="flex w-full items-center mb-2">
							<div className="w-[32px] h-[32px] flex-grow-0 flex-shrink-0 mr-2">
								<UserAvatar user={video.User} />
							</div>

							<div className="flex-1 min-w-0">
								<Username user={video.User} />
							</div>
						</div>

						<h3 className="text-white font-semibold">
							{video.Thread && (
								<div className="mb-2">
									<div className="inline-block">
										<ThreadPrefixes thread={video.Thread} />
									</div>
								</div>
							)}

							<a href={video.Thread ? video.Thread.view_url : '#'} className="text-sm block">
								{video.Thread.title}
							</a>
						</h3>
					</div>

					<div className="flex-grow-0 flex-shrink-0">
						<VideoItemActionButtons video={video} isVertical={true} onOpenCommentList={onOpenCommentList} />
					</div>
				</div>
			</div>
		</>
	);
};

const VideoItemMobile = ({ video, isActive, onOpenCommentList, onCloseCommentList, isCommentListVisible }) => {
	return (
		<div id={`video-${video.attachment_id}`} className="w-full h-full relative bg-black">
			<VideoMediaPlayer video={video} isActive={isActive} onOpenCommentList={onOpenCommentList} />
			{isCommentListVisible && (
				<CommentList video={video} isActive={isActive} onClose={onCloseCommentList} />
			)}
		</div>
	);
};

export default VideoItemMobile;
